// src/pages/admin/AdminOrderManager.jsx
import React, { useEffect, useState } from 'react';
import '../styles/AdminOrderManager.css';
import AdminSidebar from "./AdminSidebar";
import { adminFetch } from "../../api/adminFetch";

const AdminOrderManager = () => {
    const [orders, setOrders] = useState([]);
    const [newOrderAlert, setNewOrderAlert] = useState(false);

    useEffect(() => {
        const prepareSound = () => {
            const audio = new Audio('/sounds/notification.mp3');
            audio.play().then(() => {
                audio.pause();
                audio.currentTime = 0;
                console.log("🔊 사운드 준비 완료");
            }).catch(() => {
                console.log("⚠️ 유저 상호작용 전에는 사운드 재생이 제한됩니다");
            });

            window.removeEventListener('click', prepareSound);
        };

        window.addEventListener('click', prepareSound);
    }, []);

    // 브라우저 알림 권한 요청
    useEffect(() => {
        if (Notification.permission !== 'granted') {
            Notification.requestPermission().then(r => {});
        }

    }, []);

    // 새 주문 감지용 타이머
    useEffect(() => {
        // 페이지 로드 시 새 주문 체크
        fetchOrders();
        console.log('주문 체크' + orders);

        // 5분 간격으로 새 주문 체크
        const interval = setInterval(() => {
            fetchOrders();
            console.log('주문 체크' + orders);
        }, 300000); // 5분 간격 체크

        return () => clearInterval(interval);
    }, []);

    // 주문 목록 가져오기
    const fetchOrders = async () => {
        adminFetch('/api/admin/orders/new') // 새 주문만 가져오는 API
            .then(res => res.json())
            .then(data => {
                if (data.count > 0) {
                    setOrders(data.orders);
                    setNewOrderAlert(true);

                    // 브라우저 알림
                    if (Notification.permission === 'granted') {
                        new Notification('새 주문 알림', {
                            body: `${data.count}개의 새로운 주문이 도착했습니다.`,
                            icon: '/softcat2.ico'
                        });
                    }

                    // 사운드 재생
                    const audio = new Audio('/sounds/notification.mp3');
                    audio.play();
                }
            })
            .catch(err => console.error('주문 불러오기 실패', err));
    };

    // 주문 상태 → 디자인 시스템 뱃지
    const statusBadge = (status) => {
        const map = {
            "결제완료": "sc-badge--paid",
            "배송중": "sc-badge--shipping",
            "배송완료": "sc-badge--done",
            "주문취소": "sc-badge--canceled",
            "취소": "sc-badge--canceled",
        };
        return `sc-badge ${map[status] || "sc-badge--done"}`;
    };

    return (
        <div className="sch-adminPage">
            <AdminSidebar />

            <div className="sch-adminMain">
                <div className="sch-adminHead">
                    <h2 className="sc-h2">주문 관리</h2>
                </div>

                {newOrderAlert && (
                    <div className="sc-alert sc-alert--info">
                        <span>{orders.length} 건의 새로운 주문이 있습니다!</span>
                    </div>
                )}

                <div className="sc-tablewrap">
                    <table className="sc-table sc-table--responsive">
                        <thead>
                            <tr>
                                <th>주문 번호</th>
                                <th>고객명</th>
                                <th>상품명</th>
                                <th className="sc-td--num">수량</th>
                                <th className="sc-td--num">주문 금액</th>
                                <th>주문 방법</th>
                                <th>상태</th>
                                <th>주문일</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order, idx) => (
                                <tr key={idx}>
                                    <td data-label="주문 번호" className="sc-td--muted">{order.orderId}</td>
                                    <td data-label="고객명">{order.buyerName}</td>
                                    <td data-label="상품명">{order.productName}</td>
                                    <td data-label="수량" className="sc-td--num">{order.orderQuantity}</td>
                                    <td data-label="주문 금액" className="sc-td--num">{order.totalPrice.toLocaleString()} 원</td>
                                    <td data-label="주문 방법" className="sc-td--muted">{order.paymentMethod}</td>
                                    <td data-label="상태">
                                        <span className={statusBadge(order.orderStatus)}>{order.orderStatus}</span>
                                    </td>
                                    <td data-label="주문일" className="sc-td--muted">
                                        {new Date(order.orderDate).toLocaleString()}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    {orders.length === 0 && (
                        <div className="sc-empty">
                            <div className="sc-empty__title">주문이 없습니다</div>
                            <div className="sc-empty__desc">새 주문이 들어오면 여기에 표시됩니다.</div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default AdminOrderManager;
